module.exports = __webpack_public_path__ + "static/img/frack02.0be50b8b.png";